import React, { Component } from 'react';
import '../../../scss/components/pages/staffList.scss';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import Pagination from '../../Pagination';
import EditStaff from '../../EditStaff';
import EditSalary from '../../EditSalary';
import moment from 'moment';
import API from '../../../middleware/API';
import {GetStoreRole, GetStoreDetailRole} from '../../../const/constant';
import axios from 'axios';
import HRDocuments from '../../HRDocuments'; // 引入 HRDocuments 組件

import QrcordBlock from '../../QrcordBlock';
import Table from '../../Table';

import { 
  getStaffList,
  editStaff,
  addStaff,
  InitAPIStatus,
  getJobTypeList,
  switchStaffstatus,
  sortStafflist
} from '../../../store/action';
import SalaryCSV from '../../SalaryCSV';

class StaffList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'StaffList',
      editType: 'ADD',
      isEditShow: false,
      isSalaryCSVOpen:false,
      currPage: 1,
      countOfPage: 10,
      isOpenQrcodeBlock: false,
      isOpenEditSalary: false,
      status: '1',
      isOpenHRDocuments: false, // 控制 HRDocuments 的顯示狀態
      selectedUserId: null, // 存儲當前選中的 userId
      selectedStoreId: null,
      selectedRealName: null,

      QrcordText: '',
      QrcordName: '',
      QrcordJobType: '',
      editTarget:{
        year: 0,
        month: 0,
    },
      editInformation: {
        id: -1,
        realName: '',
        birthDate: '',
        idNumber: '',
        cellPhone: '',
        isPartTime: false,
        takeOfficeDate: moment(),
        jobTypeId: 0,
        takeOffHours: 0,
        pay : '',
        notes:'',
        jobLevel:'',
        carriedForwardHours:0,
        monthSalary:0,
        lastRemainHours:0,
        compensatoryHours:0,
        signingCompensatoryHours:0,
        status: 0,
        totalHours:0,
        partTimeLeaveHours:0,
        // 新增欄位
        householdAddress: '',
        mailingAddress: '',
        emergencyContactName: '',
        emergencyContactPhone: '',
        baseSalary: '',
        salaryBank: '',
        bankAccountNumber: '',
        pensionLevel: '',
        laborInsuranceLevel: '',
        healthInsuranceLevel: '',
        healthDependentCount: '',
      },
      editSalary: {
        id: -1,
        userid: -1,
        realName: '',
        isPartTime: false,
        jobType: '',
        date: moment().startOf('month'),
        jobTypeId: 0,
        baseSalary: 0,
        fullAttendance: 0,
        performanceBonus: 0,
        dutyAllowance: 0,
        foodAllowance: 0,
        freeTaxOverTime: 0,
        bonus: 0,
        healthInsurance: 0,
        laborInsurance: 0,
        tax: 0,
        replenishHealthInsurance: 0,
        lateSalary: 0,
        incomeAmt: 0,
        losePunch: 0,
        deductionAmt: 0,
        actuallyPaidAmt: 0,
        retirementPay: 0,
        pay: 0,
        workingHours: 0,
        otherAllowance: 0,
        managerAllowance: 0,
        selfPension: 0,
        otherDeduction: 0,
        supplementaryPremium:0,
        notes: '',
      },
      searchNameInput: '',
      currentRole: GetStoreRole(localStorage.getItem('current_store_id')),
      currentDetailRole: GetStoreDetailRole(localStorage.getItem('current_store_id')) 

    }
    this.toggleEditBlockShow = this.toggleEditBlockShow.bind(this);
    this.toggleEditSalaryBlockShow = this.toggleEditSalaryBlockShow.bind(this);
    this.handleSaveStaff = this.handleSaveStaff.bind(this);
    this.handleSaveSalary = this.handleSaveSalary.bind(this);
    this.openEditStaffBlok = this.openEditStaffBlok.bind(this);
    this.openAddStaffBlock = this.openAddStaffBlock.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleOnChangeInput = this.handleOnChangeInput.bind(this);
    this.handleOnChangeSalaryInput = this.handleOnChangeSalaryInput.bind(this);
    this.handleToggleOpenQrcordBlcok = this.handleToggleOpenQrcordBlcok.bind(this);
    this.inputSearchChange = this.inputSearchChange.bind(this);
    this.statusChange = this.statusChange.bind(this);
    this.openEditSalaryBlok = this.openEditSalaryBlok.bind(this);
    this.openAddSalaryBlock = this.openAddSalaryBlock.bind(this);
    this.getSalaryByDate = this.getSalaryByDate.bind(this);
    this.CarriedForwardHours = this.CarriedForwardHours.bind(this);
    this.handleToggleOpenSalaryCSVBlock = this.handleToggleOpenSalaryCSVBlock.bind(this);
    this.handleSalaryCSV = this.handleSalaryCSV.bind(this);
    this.resetEditTarget = this.resetEditTarget.bind(this);
    this.handleOnChangeSalaryCSV = this.handleOnChangeSalaryCSV.bind(this);
    this.toggleHRDocumentsBlockShow = this.toggleHRDocumentsBlockShow.bind(this);
    this.ResetCompensatoryHours = this.ResetCompensatoryHours.bind(this);
  }

  componentDidMount() {
    this.props.getStaffList(this.state.currPage, this.state.countOfPage, this.state.searchNameInput, this.state.status);
    this.props.getJobTypeList();
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.SendAPIState === true) {
      swal({
        type: 'success',
        title: this.state.editType === 'ADD' ? '員工新增成功' : '員工修改成功',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
        this.props.getStaffList(this.state.currPage, this.state.countOfPage, this.state.searchNameInput, this.state.status);
        this.setState({
          isEditShow: false
        })
      });
      return 
    } else if (nextProps.SendAPIState === 2) {
      swal({
        type: 'error',
        title: '員工身分證重複',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
      });
      return 
    } else if (nextProps.SendAPIState === 18) {
      swal({
        type: 'error',
        title: '員工手機重複',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
      });
      return 
    }else if (nextProps.SendAPIState === 19) {
      swal({
        type: 'error',
        title: '員工生日格式錯誤，請查看範例',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      }).then((result) => {
        nextProps.InitAPIStatus();
      });
      return 
    }
    
  }
  toggleHRDocumentsBlockShow(userId = null, realName = null, storeId = null) {
    this.setState((prevState) => ({
      isOpenHRDocuments: !prevState.isOpenHRDocuments,
      selectedUserId: userId,
      selectedRealName: realName,
      selectedStoreId: storeId,
    }));
  }

  toggleEditBlockShow() {
    if (this.state.isEditShow === true) {
      let newObj = JSON.parse(JSON.stringify((this.state.editInformation)));
      newObj.id = -1;
      newObj.realName = '';
      newObj.birthDate = '';
      newObj.idNumber = '';
      newObj.cellPhone = '';
      newObj.takeOfficeDate = moment()
      newObj.jobTypeId = 0;
      newObj.pay = '';
      newObj.notes = '';
      newObj.jobLevel = '';
      newObj.carriedForwardHours = 0;
      newObj.compensatoryHours = 0;
      newObj.signingCompensatoryHours = 0;
      newObj.monthSalary = 0;
      newObj.lastRemainHours = 0;
      newObj.totalHours=0;
      newObj.partTimeLeaveHours=0;
      newObj.status = 0;
      newObj.householdAddress= '';
      newObj.mailingAddress= '';
      newObj.emergencyContactName= '';
      newObj.emergencyContactPhone= '';
      newObj.baseSalary= '';
      newObj.salaryBank= '';
      newObj.bankAccountNumber= '';
      newObj.pensionLevel= '';
      newObj.laborInsuranceLevel= '';
      newObj.healthInsuranceLevel= '';
      newObj.healthDependentCount= '';
      
      this.setState({
        editInformation: newObj,
        isEditShow: false
      });
    } else {
       this.setState({
        isEditShow: true
      })
    }
  }
  handleToggleOpenSalaryCSVBlock(){
    this.setState({
      isSalaryCSVOpen: !this.state.isSalaryCSVOpen,
    });
  }
  resetEditTarget(){
    let emptyTarget = {
        year: 0,
        month: 0,
    }

    this.setState({
        editTarget:emptyTarget       
      });
  }
  handleOnChangeSalaryCSV(key, e){
    console.log(key)
    console.log(e.target.value)
    let newObj = Object.assign(this.state.editTarget);
    newObj[key] = e.target.value;
    this.setState({
      editTarget: newObj
  });
  }
  handleSalaryCSV(data) {
    let {year, month} = this.state.editTarget;
    var formData = new FormData();
    formData.append("Year", year);
    formData.append("Month", month);
    formData.append("File", data);

    swal({
      type: 'warning',
      title: '是否確定要上傳'+year+'年'+month+'月薪資?',
      text:'一旦上傳就不可還原，將會蓋掉該月所有薪資資料',
      showCloseButton: true,
      heightAuto: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#A9ABA8',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.value) {
        axios.post(process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/SalaryCSV/V2':'https://www.liangshishu.link:46888/api/SalaryCSV/V2'
        , formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'bearer ' + localStorage.getItem('access_token'),
          }
        }).then((res) => {
          //如果有錯誤訊息就顯示錯誤訊息，沒有的話就顯示成功
          if(res.data.message.length > 0){
            alert(res.data.message.join("\r\n"))
          }else{
            swal({
              type: 'success',
              title: '上傳成功',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false
            }).then(() => {});
          }
    
        });
      }
    })



    
  }
  openAddStaffBlock() {
    let newObj = JSON.parse(JSON.stringify((this.state.editInformation)));
    newObj.id = -1;
    newObj.realName = '';
    newObj.birthDate = '';
    newObj.idNumber = '';
    newObj.cellPhone = '';
    newObj.jobTypeId = 0;
    newObj.takeOfficeDate = moment()
    newObj.pay = '';
    newObj.notes = '';
    newObj.jobLevel = '';
    newObj.carriedForwardHours = 0;
    newObj.monthSalary = 0;
    newObj.compensatoryHours = 0;
    newObj.signingCompensatoryHours = 0;
    newObj.lastRemainHours = 0;
    newObj.totalHours=0;
    newObj.partTimeLeaveHours=0;
    newObj.status = 0;
    this.setState({
      editInformation: newObj,
      editType: 'ADD',
    }, () => {
      this.toggleEditBlockShow();
    })
  }
  
  openEditStaffBlok(staffId) {
    let staffObj = this.props.staffListState.users.filter(staff => staff.id === staffId);
    var newObj = JSON.parse(JSON.stringify(staffObj[0]));
    var currentStore = localStorage.getItem('current_store_id') === '1' ? '總店' : localStorage.getItem('current_store_id') === '2' ?'海大店':'北大店';
    newObj.takeOfficeDate = staffObj[0].takeOfficeDate.indexOf('0001') === -1 ? moment(staffObj[0].takeOfficeDate): moment();
    newObj.jobTypeId = staffObj[0].jobs[staffObj[0].jobs.findIndex(i => i.storeName === currentStore)].jobId
    this.setState({
      editType: 'EDIT',
      editInformation: newObj
    }, () => {
      this.toggleEditBlockShow();
    })
  }

  handleSaveStaff() {
    const { id, 
      realName, 
      birthDate, 
      idNumber, 
      cellPhone, 
      jobTypeId, 
      pay, 
      notes, 
      status, 
      takeOfficeDate, 
      isPartTime,
      takeOffHours, 
      jobLevel, 
      compensatoryHours,
      signingCompensatoryHours, 
      monthSalary, 
      householdAddress,
      mailingAddress,
      emergencyContactName,
      emergencyContactPhone,
      baseSalary,
      salaryBank,
      bankAccountNumber,
      pensionLevel,
      laborInsuranceLevel,
      healthInsuranceLevel,
      healthDependentCount

     } = this.state.editInformation;
    if (realName.trim() === '' || idNumber.trim() === '' || cellPhone.trim() === '' || jobTypeId === 0 || pay.toString().trim() === '') {
      swal({
        type: 'error',
        title: '所有欄位必填!',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false
      });
      return
    } else {
      if(this.state.editType === 'EDIT') {
        this.props.editStaff({
          id: id,
          realName: realName,
          birthDate: birthDate,
          idNumber: idNumber,
          cellPhone: cellPhone,
          isPartTime: isPartTime,
          compensatoryHours: compensatoryHours,
          signingCompensatoryHours: signingCompensatoryHours,
          monthSalary: monthSalary,
          jobTypeId: jobTypeId,
          takeOfficeDate:takeOfficeDate.format('YYYY-MM-DD'),
          takeOffHours: takeOffHours,
          jobLevel: jobLevel,
          pay: pay,
          notes:notes,
          status: status,
          householdAddress: householdAddress,
          mailingAddress: mailingAddress,
          emergencyContactName: emergencyContactName,
          emergencyContactPhone: emergencyContactPhone,
          baseSalary: baseSalary,
          salaryBank: salaryBank,
          bankAccountNumber: bankAccountNumber,
          pensionLevel: pensionLevel,
          laborInsuranceLevel: laborInsuranceLevel,
          healthInsuranceLevel: healthInsuranceLevel,
          healthDependentCount: healthDependentCount,
        });
      } else {
        this.props.addStaff({
          realName: realName,
          birthDate: birthDate,

          idNumber: idNumber,
          cellPhone: cellPhone,
          jobTypeId: jobTypeId,
          jobLevel:jobLevel,
          takeOffHours: takeOffHours,
          takeOfficeDate:takeOfficeDate.format('YYYY-MM-DD'),
          isPartTime: isPartTime,
          notes:notes,
          pay: pay,
          householdAddress: householdAddress,
          mailingAddress: mailingAddress,
          emergencyContactName: emergencyContactName,
          emergencyContactPhone: emergencyContactPhone,
          baseSalary: baseSalary,
          salaryBank: salaryBank,
          bankAccountNumber: bankAccountNumber,
          pensionLevel: pensionLevel,
          laborInsuranceLevel: laborInsuranceLevel,
          healthInsuranceLevel: healthInsuranceLevel,
          healthDependentCount: healthDependentCount,
        });
      }
    }
  }
    ResetCompensatoryHours(userId, realName){
    swal({
      type: 'warning',
      title: '確定要重置補休時數嗎？',
      text: '此操作將重置'+realName+'的補休時數，請確認！',
      showCloseButton: true,
      heightAuto: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#A9ABA8',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.value) {
        API.post('/User/ResetCompensatoryHours/'+userId)
                        .then((response) => {
                          console.log(response);
                          if(response){
                          // 顯示成功提示
                            swal.fire({
                              title: '重置成功',
                              text: '補休時數已成功重置。',
                              type: 'success',
                            }).then(()=>{
              this.props.getStaffList(this.state.currPage, this.state.countOfPage, this.state.searchNameInput, this.state.status);
              let newObj = Object.assign(this.state.editInformation);
                newObj['compensatoryHours'] = 0;
    
              this.setState({
                editInformation: newObj
              });
            });;
                          }else{
                            swal.fire({
                              title: '重置失敗',
                              text: '請稍後再試或聯繫管理員。',
                              type: 'error',
                            });
                          }
            
                        });
      }
    })

  }

  CarriedForwardHours(userId){
    swal({
      type: 'warning',
      title: '確定轉移時數?',
      text:'(此動作無法復原)',
      showCloseButton: true,
      heightAuto: false,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#A9ABA8',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.value) {
        API.post('Leave/HourCarriedForward?userId='+userId).then((response) => {
          if(response){
            swal({type:'success',title:'轉換成功'}).then(()=>{
              this.props.getStaffList(this.state.currPage, this.state.countOfPage, this.state.searchNameInput, this.state.status);
              let newObj = Object.assign(this.state.editInformation);
                newObj['carriedForwardHours'] = newObj['lastRemainHours'];
    
              this.setState({
                editInformation: newObj
              });
            });
          }else{
            swal({type:'error',title:'發生錯誤',
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false});
          }
        })
      }
    })

  }

  handleSaveSalary() {        
    var data = this.state.editSalary;
    data.date = data.date.format('YYYY-MM-DD');
    if(data.isPartTime){
      data.incomeAmt =  Math.round(
      (data.pay * data.workingHours) + 
      data.freeTaxOverTime + 
      data.bonus + 
      data.fullAttendance + 
      data.performanceBonus + 
      data.dutyAllowance +
      data.foodAllowance +
      data.otherAllowance
      //+data.managerAllowance
      )
    }else{
      data.incomeAmt = Math.round(
      data.baseSalary + 
      data.freeTaxOverTime + 
      data.bonus + 
      data.fullAttendance + 
      data.performanceBonus + 
      data.dutyAllowance +
      data.foodAllowance +
      data.otherAllowance 
      //+data.managerAllowance
      ) 
    }
    data.deductionAmt =     data.healthInsurance + 
    data.laborInsurance + 
    data.lateSalary + 
    data.sickLeaveSalary + 
    data.pointSalary + 
    data.personalLeaveSalary+
    data.selfPension + 
    data.otherDeduction+
    data.retirementPay + 
    data.supplementaryPremium;

    data.actuallyPaidAmt = data.incomeAmt - data.deductionAmt;
    if(this.state.editType === 'EDIT') {
      API.put('Salary/'+this.state.editSalary.id, data).then((response) => {
        if (response) {
            this.toggleEditSalaryBlockShow();
            this.props.getStaffList(this.state.currPage, this.state.countOfPage, this.state.searchNameInput, this.state.status);
        }else{
          swal({
            type: 'error',
            title: '薪資條編輯失敗，請回報工程師',
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false
          })
        }
      });
    } else {
      API.post('Salary', data).then((response) => {
        if (response) {
            this.toggleEditSalaryBlockShow();
            this.props.getStaffList(this.state.currPage, this.state.countOfPage, this.state.searchNameInput, this.state.status);
        }else{
          swal({
            type: 'error',
            title: '薪資條新增失敗，請回報工程師',
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false
          })
        }
      });
    }
  }


  handleChangePage(page) {
    const { countOfPage } = this.state;
    this.setState({currPage: page},() => {
      this.props.getStaffList(this.state.currPage, countOfPage, this.state.searchNameInput, this.state.status);
    })
  }

  handleOnChangeInput(key, e) {
    let newObj = Object.assign(this.state.editInformation);
    if(moment.isMoment(e)){
      newObj[key] = e;
    }else{
      newObj[key] = e.target.value;
    }
    this.setState({
      editInformation: newObj
    });
  }

  getSalaryByDate(){
    let newObj = Object.assign(this.state.editSalary);
    console.log(newObj)
    let staffObj = this.props.staffListState.users.filter(staff => staff.id == newObj['userid'])[0];
    API.get('Salary/'+newObj['userid']+'/'+newObj['date'].format('YYYY')+'/'+ newObj['date'].format('MM')).then((response) => {
      if (response) {
          if (response.id === 0){

            console.log('A')
            response.realName = newObj['realName'];
            response.userid = newObj['userid'];
            response.jobType = newObj['jobType'];
            response.jobTypeId = newObj['jobTypeId'];
            response.date =  newObj['date'];
            response.jobLevel =  newObj['jobLevel'];
            response.isPartTime =  newObj['isPartTime'];
            //response.healthInsurance =  0;
            //response.laborInsurance =  0;

              //response.healthInsurance = newObj['healthInsurance']?newObj['healthInsurance']:staffObj.lastSalary?staffObj.lastSalary.healthInsurance:0;
              //response.laborInsurance = newObj['laborInsurance']?newObj['laborInsurance']:staffObj.lastSalary?staffObj.lastSalary.laborInsurance:0;


            this.setState({
              editType: 'ADD',
              editSalary: response
            });
          }else{
            console.log('B')

            response.realName = newObj['realName']
            response.userid = newObj['userid']
            response.jobType = newObj['jobType']
            response.jobTypeId = newObj['jobTypeId'];
            response.jobLevel =  newObj['jobLevel'];
            response.date = moment(response.date);
            response.isPartTime =  newObj['isPartTime'];
            //response.healthInsurance =  newObj['healthInsurance'];
            //response.laborInsurance =  newObj['laborInsurance'];


              //response.healthInsurance = response.healthInsurance?response.healthInsurance:staffObj.lastSalary?staffObj.lastSalary.healthInsurance:0;
              //response.laborInsurance = response.laborInsurance?response.laborInsurance:staffObj.lastSalary?staffObj.lastSalary.laborInsurance:0;

                        console.log(response)
            this.setState({
              editType: 'EDIT',
              editSalary: response
            });
          }
      }
    });

  }

  handleOnChangeSalaryInput(key, e) {
    console.log(e.target.value)
    let newObj = Object.assign(this.state.editSalary);
    if(moment.isMoment(e)){
      newObj[key] = e;
    }else if(key === 'notes'){
      newObj[key] = e.target.value;
    }else if(key === 'workingHours'){
      newObj[key] = parseFloat(e.target.value, 10);
    }else if(key === 'month'){
      newObj['date'].set('month', e.target.value)
      this.getSalaryByDate();
    }else if(key === 'year'){
      newObj['date'].set('year', e.target.value)
      this.getSalaryByDate();
    }else{
      if(e.target.value === ''){
        newObj[key] = 0;
      }else{
        newObj[key] = parseInt(e.target.value, 10);
      }
    }
    
    if(newObj['isPartTime']){
      console.log('A')
      newObj['incomeAmt'] =  Math.round(
      (newObj['pay'] * newObj['workingHours']) + 
      newObj['freeTaxOverTime'] + 
      newObj['bonus'] + 
      newObj['fullAttendance'] + 
      newObj['performanceBonus'] + 
      newObj['dutyAllowance'] +
      newObj['foodAllowance'] +
      newObj['otherAllowance'] 
      //+newObj['managerAllowance']
      )
    }else{
      console.log('B')
      newObj['incomeAmt'] = Math.round(
      newObj['baseSalary'] + 
      newObj['freeTaxOverTime'] + 
      newObj['bonus'] + 
      newObj['fullAttendance'] + 
      newObj['performanceBonus'] + 
      newObj['dutyAllowance'] +
      newObj['foodAllowance'] +
      newObj['otherAllowance'] 
     // +newObj['managerAllowance']
      ) 
    }
    console.log('C')
    console.log(newObj['retirementPay'])

    newObj['deductionAmt'] = Math.round(
    newObj['healthInsurance'] + 
    newObj['laborInsurance'] + 
    newObj['lateSalary'] + 
    newObj['sickLeaveSalary'] + 
    newObj['pointSalary'] + 
    newObj['personalLeaveSalary']+
    newObj['selfPension'] + 
    newObj['otherDeduction']+
    newObj['retirementPay']+ 
    newObj['supplementaryPremium']
    )

    newObj['actuallyPaidAmt'] = newObj['incomeAmt'] - newObj['deductionAmt']
    console.log(newObj)

    this.setState({
      editSalary: newObj
    });
  }

  handleToggleOpenQrcordBlcok(){
    this.setState({
      isOpenQrcodeBlock: !this.state.isOpenQrcodeBlock
    })
  }

  handleOpenQrcordBlcok(text, name, jobType){
    this.setState({
      QrcordText: text,
      QrcordName: name,
      QrcordJobType: jobType,
      isOpenQrcodeBlock: true
    })
  }

  toggleEditSalaryBlockShow() {
    if (this.state.isOpenEditSalary === true) {
      let newObj = JSON.parse(JSON.stringify((this.state.editSalary)));
      newObj.id = -1;
      newObj.realName = '';
      newObj.jobLevel = '';
      newObj.jobType = '';
      newObj.date = moment().startOf('month')
      newObj.jobTypeId = 0;
      this.setState({
        editSalary: newObj,
        isOpenEditSalary: false
      });
    } else {
       this.setState({
        isOpenEditSalary: true
      })
    }
  }

  openAddSalaryBlock() {
    let newObj = JSON.parse(JSON.stringify((this.state.editSalary)));
    newObj.id = -1;
    newObj.realName = '';
    newObj.jobLevel = '';
    newObj.jobType = '';
    newObj.jobTypeId = 0;
    newObj.date = moment().add(-1,'month').startOf('month')
    this.setState({
      editSalary: newObj,
      editType: 'ADD',
    }, () => {
      this.toggleEditSalaryBlockShow();
    })
  }
  
  openEditSalaryBlok(staffId, realName, jobType, jobTypeId, jobLevel) {
    let newObj = JSON.parse(JSON.stringify((this.props.staffListState.users.find(m=>m.id === staffId))));
    console.log(newObj.salary)
    newObj.id = newObj.salary ? newObj.salary.id : -1;
    newObj.userid = staffId;
    newObj.realName = realName;
    newObj.jobType = jobType;
    newObj.jobLevel = jobLevel;
    newObj.jobTypeId = jobTypeId;
    newObj.pay = newObj.salary ? newObj.salary.pay : 0;
    newObj.baseSalary= newObj.salary ? newObj.salary.baseSalary : 0;
    newObj.fullAttendance= newObj.salary ? newObj.salary.fullAttendance : 0;
    newObj.performanceBonus= newObj.salary ? newObj.salary.performanceBonus : 0;
    newObj.dutyAllowance= newObj.salary ? newObj.salary.dutyAllowance : 0;
    newObj.foodAllowance= newObj.salary ? newObj.salary.foodAllowance : 0;
    newObj.freeTaxOverTime= newObj.salary ? newObj.salary.freeTaxOverTime : 0;
    newObj.bonus= newObj.salary ? newObj.salary.bonus : 0;
    newObj.healthInsurance= newObj.salary ? newObj.salary.healthInsurance : 0;
    newObj.laborInsurance= newObj.salary ? newObj.salary.laborInsurance : 0;
    //newObj.healthInsurance= newObj.salary && newObj.salary.healthInsurance!=0? newObj.salary.healthInsurance:newObj.lastSalary ? newObj.lastSalary.healthInsurance:0;
    //newObj.laborInsurance= newObj.salary && newObj.salary.laborInsurance!=0? newObj.salary.laborInsurance:newObj.lastSalary ? newObj.lastSalary.laborInsurance:0;
    newObj.tax= newObj.salary ? newObj.salary.tax : 0;
    newObj.replenishHealthInsurance= newObj.salary ? newObj.salary.replenishHealthInsurance : 0;
    newObj.lateSalary= newObj.salary ? newObj.salary.lateSalary : 0;
    newObj.incomeAmt= newObj.salary ? newObj.salary.incomeAmt : 0;
    newObj.losePunch= newObj.salary ? newObj.salary.losePunch : 0;
    newObj.deductionAmt= newObj.salary ? newObj.salary.deductionAmt : 0;
    newObj.actuallyPaidAmt= newObj.salary ? newObj.salary.actuallyPaidAmt : 0;
    newObj.retirementPay= newObj.salary ? newObj.salary.retirementPay : 0;
    newObj.workingHours= newObj.salary ? newObj.salary.workingHours : 0;
    newObj.personalLeaveSalary= newObj.salary ? newObj.salary.personalLeaveSalary : 0;
    newObj.sickLeaveSalary= newObj.salary ? newObj.salary.sickLeaveSalary : 0;
    newObj.pointSalary= newObj.salary ? newObj.salary.pointSalary : 0;
    newObj.otherAllowance= newObj.salary ? newObj.salary.otherAllowance : 0;
    //newObj.managerAllowance= newObj.salary ? newObj.salary.managerAllowance : 0;
    newObj.selfPension= newObj.salary ? newObj.salary.selfPension : 0;
    newObj.otherDeduction= newObj.salary ? newObj.salary.otherDeduction : 0;
    newObj.supplementaryPremium= newObj.salary ? newObj.salary.supplementaryPremium : 0;
    newObj.notes= newObj.salary ? newObj.salary.notes : '';
    newObj.date =moment().add(-1,'month').startOf('month')

    //拿現有資料?
    this.setState({
      editType: newObj.salary ? 'EDIT':'ADD',
      editSalary: newObj
    }, () => {
      this.toggleEditSalaryBlockShow();
    })
  }


  statusChange(e) {
    this.setState({
      status: e.target.value,
      currPage: 1
    })
    this.setState({status: e.target.value},() => {
      this.props.getStaffList(1, this.state.countOfPage, this.state.searchNameInput, this.state.status);
    })
  }

  inputSearchChange(e) {
    this.setState({
      searchNameInput: e.target.value
    })
  }

  render() {
    let { users, count } = this.props.staffListState;
    var currentStore = localStorage.getItem('current_store_id') === '1' ? '總店' : localStorage.getItem('current_store_id') === '2' ?'海大店':'北大店';

    users.forEach((element) => {
      if (element.jobs && element.jobs[element.jobs.findIndex(i => i.storeName === currentStore)]){
        var currentJob = element.jobs[element.jobs.findIndex(i => i.storeName === currentStore)].jobName
        element.jobType = currentJob;
      }

    });
    let totalPage = Math.ceil(count / this.state.countOfPage);

    const columns = [
      {
        title:'建檔時間',
        field:'createAt',
        property: false,
        render: (props) => (
          <span>{props.createAt.substr(0, 10)}</span>
        ),
      },
      {
        title:'ID',
        field:'id',
        property: false
      },
      {
        title:'全名',
        field:'realName',
        property: false
      },
      {
        title:'身分證字號',
        field:'idNumber',
        property: false
      },
      {
        title:'手機',
        field:'cellPhone',
        property: false
      },
      {
        title:'職位',
        field:'jobType',
        property: false
      },

      {
        title:'在職狀態',
        field:'status',
        property: false,
        render: (props) => (
          <div className="u-check-box">
            <input id={`chk_${props.id}`} type="checkbox" checked={props.status === 1 ? true : false}
              onChange={()=>{

                this.setState({
                  status: props.status === 1 ? '0' : '1',
                  currPage: 1
                }, () => {
                  this.props.switchStaffstatus({
                    userId: props.id,
                    status: props.status === 1 ? '0' : '1' 
                  }, this.state.currPage);
                })


              }}/>
            <label htmlFor={`chk_${props.id}`}></label>
          </div>
        ),
      },
      {
        title:'操作',
        field:'action',
        property: false,
        render: (props) => (
          <a href="/" className="btn btn-md main-color" onClick={(e)=>{
            e.preventDefault();
            this.openEditStaffBlok(props.id);
          }}>編輯</a>
        ),
      },
      {
        title: '文件',
        field: 'documents',
        property: false,
        render: (props) => (
          
          <a
            href="/"
            className="btn btn-md main-color"
            onClick={(e) => {
              e.preventDefault();
              console.log(props.id, props.realName, this.state.storeId);
              this.toggleHRDocumentsBlockShow(props.id, props.realName, this.state.storeId); // 傳入 userId 和 realName
            }}
          >
            查看
          </a>

        ),
      },
      {
        title:'QRcode',
        field:'qrcode',
        property: false,
        render: (props) => (
          <a href="/" className="btn btn-md success" onClick={(e) => {
            e.preventDefault();
            this.handleOpenQrcordBlcok(props.qrCode, props.realName, props.jobType)
          }}>查看</a>
        ),
      },
      // {
      //   title:'薪資條',
      //   field:'salaryReceipt',
      //   property: false,
      //   render: (props) => (
      //     <a href="/" className={`${props.salary?'btn btn-md slide-bar-font-color-active':'btn btn-md color-dark-green'}`} onClick={(e) => {
      //       e.preventDefault();
      //       this.openEditSalaryBlok(props.id, props.realName, props.jobType, props.jobTypeId, props.jobLevel)
      //     }}>{props.salary ?'編輯':'新增'}</a>
      //   ),
      // },
    ];
    if((
      this.state.currentRole == 1 ||
      this.state.currentRole == 2 ||
      this.state.currentRole == 3) && 
      this.state.currentDetailRole != 2 && 
      this.state.currentDetailRole != 41)
      columns.push(
        {
        title:'薪資',
        field:'pay',
        property: false
        }
      );
    if((this.state.currentRole == 1 ||this.state.currentRole == 2 ||this.state.currentRole == 3) && this.state.currentDetailRole != 2 && this.state.currentDetailRole != 41)
      columns.push(
        {
          title:'薪資條',
          field:'salaryReceipt',
          property: false,
          render: (props) => (
            <a href="/" className={`${props.salary?'btn btn-md slide-bar-font-color-active':'btn btn-md color-dark-green'}`} onClick={(e) => {
              e.preventDefault();
              this.openEditSalaryBlok(props.id, props.realName, props.jobType, props.jobTypeId, props.jobLevel)
            }}>{props.salary ?'編輯':'新增'}</a>
          ),
        }
      );

    return (
      <div className="p-staff-list">
        <div className="u-block u-block--fixHeight">
          <div className="u-title">員工列表</div>
          <div className="u-btn-group p-0" style={{justifyContent: 'flex-end'}}>
            <div className="form-group" style={{textAlign: 'right', width: '95px'}}>
            <label>
              <input
                type="radio"
                name="react-tips"
                value="1"
                checked={this.state.status === '1'}
                className="form-check-input"
                onChange={this.statusChange} 
              />
              在職
            </label>&nbsp;&nbsp;<br/>
            <label style={{color: 'red'}}>
              <input
                type="radio"
                name="react-tips"
                value="0"
                checked={this.state.status === '0'}
                className="form-check-input"
                onChange={this.statusChange} 
              />
              離職
            </label>&nbsp;&nbsp;
            </div>
            <div className="search-box" style={{display: 'flex'}}>
              <div className="date-input">
                <input className="u-form__input" value={this.state.searchNameInput} placeholder="請輸入姓名" onChange={this.inputSearchChange} 
                  onKeyPress={(event) => {
                    if(event.key === 'Enter'){
                      this.props.getStaffList(1, this.state.countOfPage, this.state.searchNameInput, this.state.status);
                    }
                  }}/>
              </div>
              <button className="btn btn-md save m-l-8" onClick={() => {
                this.props.getStaffList(1, this.state.countOfPage, this.state.searchNameInput, this.state.status);
              }}>查詢</button>
              <button className="btn btn-md success m-l-8" onClick={this.openAddStaffBlock}>新增員工</button>
              {
                (this.state.currentRole == 2 || this.state.currentRole ==3) && this.state.currentDetailRole != 2?
                <button
                type="button"
                className="btn edit btn-md"
                onClick={() => {
                  this.handleToggleOpenSalaryCSVBlock()
                }}
                >
                  <span>上傳薪資</span>
                </button>:
                ''

              }

            </div>
          </div>
          <Table columns={columns} datas={users} />

          {/* <div className="u-table-responsive">
            <table className="u-table u-table-border u-table-striped">
              <thead>
                <tr>
                    <th className="sort" onClick={()=>{this.props.sortStafflist('createAt')}}>建檔時間<i className="fas fa-angle-down"></i></th>
                    <th className="sort" onClick={()=>{this.props.sortStafflist('id')}}>ID<i className="fas fa-angle-down"></i></th>
                    <th className="sort" onClick={()=>{this.props.sortStafflist('realName')}}>全名<i className="fas fa-angle-down"></i></th>
                    <th className="sort" onClick={()=>{this.props.sortStafflist('idNumber')}}>身分證字號<i className="fas fa-angle-down"></i></th>
                    <th>手機</th>
                    <th>職位</th>
                    <th>薪資</th>
                    <th>在職狀態</th>
                    <th>操作</th>
                    <th>QRcode</th>
                    <th>薪資條</th>
                </tr>
              </thead>
              <tbody>
                {
                  users.map(user => (
                    <tr key={user.id}>
                      <td>{user.createAt.substr(0, 10)}</td>
                      <td>{user.id}</td>
                      <td>{user.realName}</td>
                      <td>{user.idNumber}</td>
                      <td>{user.cellPhone}</td>
                      <td>{user.jobType}</td>
                      <td>{user.pay}</td>
                      <td>
                        <div className="u-check-box">
                          <input id={`chk_${user.id}`} type="checkbox" checked={user.status === 1 ? true : false}
                            onChange={()=>{

                              this.setState({
                                status: user.status === 1 ? '0' : '1',
                                currPage: 1
                              }, () => {
                                this.props.switchStaffstatus({
                                  userId: user.id,
                                  status: user.status === 1 ? '0' : '1' 
                                }, this.state.currPage);
                              })


                            }}/>
                          <label htmlFor={`chk_${user.id}`}></label>
                        </div>
                      </td>
                      <td>
                        <a href="/" className="btn btn-md main-color" onClick={(e)=>{
                          e.preventDefault();
                          this.openEditStaffBlok(user.id);
                        }}>編輯</a>
                      </td>
                      <td>
                        <a href="/" className="btn btn-md success" onClick={(e) => {
                          e.preventDefault();
                          this.handleOpenQrcordBlcok(user.qrCode, user.realName, user.jobType)
                        }}>查看</a>
                      </td>
                      <td>
                        <a href="/" className={`${user.salary?'btn btn-md slide-bar-font-color-active':'btn btn-md color-dark-green'}`} onClick={(e) => {
                          e.preventDefault();
                          this.openEditSalaryBlok(user.id, user.realName, user.jobType, user.jobTypeId)
                        }}>{user.salary ?'編輯':'新增'}</a>
                      </td>
                    </tr>)
                  )
                }
              </tbody>
            </table>
          </div> */}
          <Pagination
            currPage={this.state.currPage} totalPage={totalPage}
            onChangPage={this.handleChangePage}
          />
          <EditStaff 
            editType={this.state.editType}
            isShow={this.state.isEditShow}
            editInformation={this.state.editInformation}
            editSalary={this.state.editSalary}
            jobTypeArray={this.props.jobTypeState}
            CarriedForwardHours={this.CarriedForwardHours}
            onChangeFunc={this.handleOnChangeInput}
            saveFunc={this.handleSaveStaff}
            toggleFunc={this.toggleEditBlockShow}
            ResetCompensatoryHours={this.ResetCompensatoryHours}
          />
          <QrcordBlock 
            isVisible={this.state.isOpenQrcodeBlock}
            QrcordName={this.state.QrcordName}
            QrcordText={this.state.QrcordText}
            QrcordJobType={this.state.QrcordJobType}
            toggleOpen={this.handleToggleOpenQrcordBlcok}
          />
          <EditSalary 
            editType={this.state.editType}
            isShow={this.state.isOpenEditSalary}
            editSalary={this.state.editSalary}
            onChangeFunc={this.handleOnChangeSalaryInput}
            saveFunc={this.handleSaveSalary}
            toggleFunc={this.toggleEditSalaryBlockShow}
          />
        <HRDocuments
          userId={this.state.selectedUserId} // 傳入選中的 userId
          realName={this.state.selectedRealName} // 傳入選中的 realName
          isShow={this.state.isOpenHRDocuments} // 控制顯示狀態
          toggleFunc={this.toggleHRDocumentsBlockShow} // 傳入切換函數
        />
          <SalaryCSV 
          isVisible={this.state.isSalaryCSVOpen} 
          toggleOpen={this.handleToggleOpenSalaryCSVBlock} 
          editTarget={this.state.editTarget}
          saveWorkRecordFunc={this.handleSalaryCSV}
          onChangeFunc={this.handleOnChangeSalaryCSV}
        />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  loginState: store.loginState,
  SendAPIState: store.SendAPIStatusState,
  jobTypeState: store.jobTypeState,
  staffListState: store.staffListState
})

export default connect(mapStateToProps,{
  getStaffList,
  getJobTypeList,
  InitAPIStatus,
  addStaff,
  switchStaffstatus,
  editStaff,
  sortStafflist
})(StaffList)

